import { me } from '../../core/selectors.js';
import { S } from '../../core/store.js';
import { toMin } from '../../core/util.js';

export function shiftHrs(s){return (toMin(s.end)-toMin(s.start))/60}

export const SHIFT_T={shoot:{n:'Shoot',c:'#f0766b'},edit:{n:'Edit',c:'#8f7be6'},office:{n:'Office',c:'#8a8f9b'},travel:{n:'Travel',c:'#e0a526'}};

export const CAP=8;

export const t12=t=>{const m=toMin(t);const h=Math.floor(m/60),mm=m%60;return (h%12||12)+(mm?':'+String(mm).padStart(2,'0'):'')+(h<12?'am':'pm')};

export const leaveOn=(uid,d)=>S.roster.leave.find(l=>l.uid===uid&&l.status!=='Declined'&&l.from<=d&&l.to>=d);

export function seeShifts(uid){const m=me();return S.roster.shifts.filter(s=>s.uid===uid&&(m.role!=='member'||s.pub));}

export function briefInfo(p){
  if(!p||!p.brief)return {};const g=t=>p.brief.slides.find(s=>s.type===t)||{};const notes=String(g('notes').body||'').split('\n').map(x=>x.trim()).filter(Boolean);
  return {loc:g('location'),sched:g('schedule'),notes};
}
